import { render, staticRenderFns } from "./ClientNoteList.vue?vue&type=template&id=b9b67444&"
import script from "./ClientNoteList.vue?vue&type=script&lang=js&"
export * from "./ClientNoteList.vue?vue&type=script&lang=js&"
import style0 from "./ClientNoteList.vue?vue&type=style&index=0&id=b9b67444&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports